import {InjectionToken, Signal} from '@angular/core';
import {
  ApiCisternListResponseDto,
  ApiCisternRequestDto,
  ApiCisternResponseDto,
} from '@birco/rainmesh-api';
import {Observable} from 'rxjs';

export interface CisternStateService {

  getCistern: (id: string) => Observable<ApiCisternResponseDto | null>;

  getCisterns(options: {
    searchTerm?: string,
    pageSize?: number,
    page?: number,
    sortBy?: string,
    sortDir?: string,
  }): Observable<ApiCisternListResponseDto>;

  createCistern: (requestDto: ApiCisternRequestDto) => Observable<ApiCisternResponseDto>;

  updateCistern: (id: string, requestDto: ApiCisternRequestDto) => Observable<ApiCisternResponseDto>;

  deleteCistern: (id: string) => Observable<any>;
}

export const CISTERN_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<CisternStateService>('CisternStateService');
